export const SET_HTTP_ERROR_CODE = "SET_HTTP_ERROR_CODE";
